/* eslint-disable func-names */
import * as Yup from 'yup';

export default Yup.object().shape({
  holderName: Yup.string()
    .required('Por favor ingresa el nombre del titular de la tarjeta')
    .min(2, 'El nombre del titular debe tener al menos 2 caracteres'),
  cardNumber: Yup.string()
    .required('El número de tarjeta es requerido')
    .matches(/^\d+$/, 'El número de tarjeta solo debe contener dígitos')
    .min(13, 'El número de tarjeta debe tener entre 13 y 19 dígitos')
    .max(19, 'El número de tarjeta debe tener entre 13 y 19 dígitos'),
  expirationMonth: Yup.string()
    .required('El mes de expiración es requerido')
    .matches(/^(0[1-9]|1[0-2])$/, 'El mes de expiración debe ser un número entre 01 y 12')
    .test('month', 'El mes de expiración debe ser un número entre 01 y 12', function(value) {
      if (!value) return false;
      const month = parseInt(value, 10);
      return !Number.isNaN(month) && month >= 1 && month <= 12;
    }),
  expirationYear: Yup.string()
    .required('El año de expiración es requerido')
    .matches(/^\d{4}$/, 'El año de expiración debe tener 4 dígitos (ej: 2025)')
    .test('year', 'El año de expiración debe ser un año futuro válido', function(value) {
      if (!value || value.length !== 4) return false;
      const year = parseInt(value, 10);
      const currentYear = new Date().getFullYear();
      return !Number.isNaN(year) && year >= currentYear;
    }),
  cvv: Yup.string()
    .required('El CVV es requerido')
    .matches(/^\d+$/, 'El CVV solo debe contener dígitos')
    .min(3, 'El CVV debe tener 3 o 4 dígitos')
    .max(4, 'El CVV debe tener 3 o 4 dígitos')
});

